var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPropertyAndConstruction = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Construction-Building--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Construction Building Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.41a1 1 0 0 0 -1 -1h-5.45a0.47 0.47 0 0 1 -0.32 -0.12L6.54 0.4a1.7 1.7 0 0 0 -2.25 0.34l-4 4a1.38 1.38 0 0 0 -0.29 0.78v3.39a1.5 1.5 0 0 0 1.5 1.5H2a0.5 0.5 0 0 1 0.5 0.5v8.48a0.5 0.5 0 0 1 -0.5 0.5H1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h22a1 1 0 0 0 1 -1v-9a1 1 0 0 0 -1 -1h-3a1 1 0 0 0 -1 1v2.5a0.5 0.5 0 0 1 -0.5 0.5h-0.75a0.5 0.5 0 0 1 -0.5 -0.5v-2.25a1 1 0 0 0 -2 0v2.25a0.5 0.5 0 0 1 -0.5 0.5h-0.5a0.5 0.5 0 0 1 -0.5 -0.5v-2.25a1 1 0 0 0 -2 0v2.25a0.5 0.5 0 0 1 -0.5 0.5H11a1 1 0 0 0 -1 1v1.5a0.5 0.5 0 0 1 -0.5 0.5H9a0.5 0.5 0 0 1 -0.5 -0.5v-8.48a0.5 0.5 0 0 1 0.5 -0.5h6.5a0.5 0.5 0 0 1 0.5 0.5v0.49a1 1 0 0 0 2 0ZM2 6.91a0.5 0.5 0 0 1 0.5 -0.5h13a0.49 0.49 0 0 1 0.5 0.49v1a0.5 0.5 0 0 1 -0.5 0.5h-13a0.5 0.5 0 0 1 -0.5 -0.5Zm3.3 -4.35a0.49 0.49 0 0 1 0.67 0l1.2 1a0.52 0.52 0 0 1 0.15 0.56 0.5 0.5 0 0 1 -0.47 0.33h-2.2a0.5 0.5 0 0 1 -0.35 -0.86ZM5 19.89a0.5 0.5 0 0 1 -0.5 -0.5v-8.48a0.5 0.5 0 0 1 0.5 -0.5h1a0.5 0.5 0 0 1 0.5 0.5v8.48a0.5 0.5 0 0 1 -0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPropertyAndConstruction);
export default ForwardRef;